// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0051d9e7","703":"f815e097"}[chunkId] + ".chunk.js";
};